import { Tab, Tabs } from "react-bootstrap";
import { useState } from "react";
import XlsGeneratorHome from "./Components/CrearExcel";
import TitleGeneratorHome from "./Components/CrearTitulos";
import ChargeRegProp from "./Components/CargarRegistros";
import ListTitleHome from "./Components/ListadoTitulosCreados";

const CreacionTitulos = () => {
  const [key, setKey] = useState("inicio");

  const handleKey = (e) => {
    setKey(e);
  };

  return (
    <div className="section-content section-creacion-titulos">
      <div className="section-title">
        <span>Creación de Títulos</span>
      </div>
      <Tabs
        activeKey={key}
        onSelect={handleKey}
        className="mt-5 w-full"
        fill
      >
        <Tab eventKey="inicio" title={<span className="tab-title">1 - Crear Excel</span>}>
          <XlsGeneratorHome />
        </Tab>
        <Tab eventKey="crearTitulos" title={<span className="tab-title">2 - Crear Títulos</span>}>
          <TitleGeneratorHome />
        </Tab>
        {/* Ver si esto lo dejo así o lo cambio de alguna forma */}
        <Tab eventKey="ListadoTitulosCreados" title={<span className="tab-title">Listado Títulos Creados</span>}>
          {
            key === "ListadoTitulosCreados"
              ? <ListTitleHome />
              : null
          }
        </Tab>
        <Tab eventKey="CargarRegistros" title={<span className="tab-title">Cargar Registros Inmueble Prov</span>}>
          <ChargeRegProp />
        </Tab>
      </Tabs>
    </div>
  );
};


export default CreacionTitulos;